
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/digital-payment-software",
      function () {
        return require("private-next-pages/features/digital-payment-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/digital-payment-software"])
      });
    }
  